import { migrateSlideContentObjects } from '../migrations';
import { getTransitionById } from '../reducers/transitionsReducer';

export const migrateFirebasePresentationToArray = ({
  presentation,
  transitions,
}) => {
  const { slides: firebaseSlides } = presentation;
  const _slides = presentation.order
    .map(
      slideID =>
        firebaseSlides[slideID]?.visible !== false && firebaseSlides[slideID],
    )
    .filter(Boolean);
  _slides.forEach(slide => {
    if (transitions && slide.transition) {
      slide.transition = getTransitionById(transitions, slide.transition.id);
    }
    if (slide.content) {
      if (slide.content.objects) {
        slide.content.objects = migrateSlideContentObjects(
          slide.content.objects,
        );
      } else {
        slide.content.objects = [];
      }
    }
  });
  return _slides;
};

export const handleFirebaseError = e => {
  console.error(e);
};
